import { render, staticRenderFns } from "./AdminRain.vue?vue&type=template&id=f644cdd8&scoped=true"
import script from "./AdminRain.vue?vue&type=script&lang=js"
export * from "./AdminRain.vue?vue&type=script&lang=js"
import style0 from "./AdminRain.vue?vue&type=style&index=0&id=f644cdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f644cdd8",
  null
  
)

export default component.exports